import BaseObject from '../../../../base/base_object';
import _ from "../../../../utils/underscore";
import Device from '../../../../utils/device';
import {KEY_NAME} from "../../native/native_const";

/**
 *
 *
 */


const DEPOSIT_WIDGET_KEY = 'shouldOpenInSecoundWebView=true';

class DepositWidget extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'DepositWidget';
    _HybridService = null;
    _bEnable = false;
    _bDepositWidgetSupported = false;




    init(params) {

        super.init();

        if(_.isNullOrUndefined(params)){
            return;
        }

        if (Device.isIOS()) {
            params = params.ios;
        } else if (Device.isAndroid()) {
            params = params.android;
        }

        if(!_.isNullOrUndefined(params)){
            this._bEnable = params.enable;
        }
    }

    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        if(this._bEnable){
            this.initFeature();
        }

        return this;
    }

    initFeature(){

        let dt = {[KEY_NAME.URL]: DEPOSIT_WIDGET_KEY};

        this._HybridService.checkHybridSupportDepositWidget(dt).then(data => {
            this._bDepositWidgetSupported = true;
            this._HybridService.updateDepositWidgetSupported();
        });
    }

    isDepositWidgetSupported() {
        return this._bDepositWidgetSupported;
    }

}


export default DepositWidget;
